export default "<div class=\"resourcePicker\">\n    <div data-dojo-attach-point=\"tableContainer\" class=\"tableContainer\">\n\n    </div>\n</div>"